export default __webpack_public_path__ + "static/media/carousel-arrow.f62ae99c.svg";